import ApiBase, { baseUrl } from '.';

export default class ModuleServiceApi extends ApiBase {
  constructor(token) {
    super(`${baseUrl}/api/services/app/ModuleService`, token);
  }

  get(id) {
    return this.authHttp.get(`${this.baseUrl}/Get`, { params: { id: id } });
  }

  create(module) {
    return this.authHttp.post(`${this.baseUrl}/Create`, module);
  }

  update(module) {
    return this.authHttp.put(`${this.baseUrl}/Update`, module);
  }

  delete(id) {
    return this.authHttp.delete(`${this.baseUrl}/Delete`, {
      params: { id: id }
    });
  }
}
